// extracted by mini-css-extract-plugin
export default {"list":"Step2--list--ytGta","spinner":"Step2--spinner--1VcOL"};